
export const text = `Now remember, if any of the signs in this video don't apply to you, your video may in fact be haunted. This is preferable. Ghosts do not have knives or replace my children. If you want to see the ghost checklist, simply click the link in the description. If at any point you do suspect that you are watching a Quotidian video, don't.



`